<template>
  <div>
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
</template>

<script>
export default {
  name: "purchase-plan-has-purchase-order-select",
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null
    },
    placeholder: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      selected: this.value ?? "",
      options: [
        { value: "", text: this.$t("purchase_plans.has_purchase_order_options.all") },
        { value: "1", text: this.$t("purchase_plans.has_purchase_order_options.exist") },
        { value: "0", text: this.$t("purchase_plans.has_purchase_order_options.not_exist") }
      ]
    };
  },
  watch: {
    selected(val, oldVal) {
      if (val !== oldVal) {
        this.$emit("input", val ?? undefined);
      }
    },
    value(val) {
      this.selected = val !== this.selected ? val ?? null : this.selected;
    }
  },
  methods: {
    onInput(event) {
      this.$emit("input", event);
    },
    clearAll() {
      this.$emit("input", undefined);
    }
  }
};
</script>

<style scoped>
</style>
